export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11320.dc152ded.jpg";